import omit from "lodash/omit"
import { Model, Schema } from "src/engine/modules/model/classes"

export const denormalizeResource = data => ({
  ...omit(data, [`id`]),
  fields: data.fields || {},
})

export const normalizeCalendarRecord = data => {
  const extractedRecords = data.reduce((result, item) => {
    const record = {
      uuid: item.resource.uuid,
      events: item.items.reduce((events, event) => {
        if (event.uuid) {
          events.push(event.uuid)
        }
        return events
      }, []),
    }
    result.push(record)
    return result
  }, [])
  return extractedRecords
}

export const mergeCalendarResources = (nextData, currentData, action) => {
  const isFirstPageLoad = action.query.offset === 0
  return isFirstPageLoad ? nextData : currentData.concat(nextData)
}

const entityName = `resources`

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `/resources/${id}` : `resources`),
  primaryKey: `uuid`,
  denormalize: denormalizeResource,
  schema: new Schema({}),
})
